import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDropboxIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 24,
	viewBox: "0 0 28 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.9997 0L0 4.5L6.9997 9L14.0006 4.5L6.9997 0Z",
				fill: "#0061FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.0004 0L14.0007 4.5L21.0004 9L28.0001 4.5L21.0004 0Z",
				fill: "#0061FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 13.5L6.9997 18L14.0006 13.5L6.9997 9L0 13.5Z",
				fill: "#0061FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.0004 9L14.0007 13.5L21.0004 18L28.0001 13.5L21.0004 9Z",
				fill: "#0061FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.99976 19.5L14.0006 24L21.0003 19.5L14.0006 15L6.99976 19.5Z",
				fill: "#0061FF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 28,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgDropboxIcon;
